/**
 * @generated SignedSource<<15ad01c9b0df46a5062d7157ae73e3f1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useFacilityGroupSize_facility$data = {
  readonly minMaxGroupSize: {
    readonly max: number | null | undefined;
    readonly min: number | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useFacilityGroupSize_facility";
};
export type useFacilityGroupSize_facility$key = {
  readonly " $data"?: useFacilityGroupSize_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFacilityGroupSize_facility">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": "STANDARD",
      "kind": "LocalArgument",
      "name": "bookingType"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useFacilityGroupSize_facility",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "bookingType",
          "variableName": "bookingType"
        }
      ],
      "concreteType": "GroupSize",
      "kind": "LinkedField",
      "name": "minMaxGroupSize",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "min",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "max",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};

(node as any).hash = "011215b619457624693ee2aaa425f06b";

export default node;
